var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 9.85714C19.9998 12.5066 19.5557 14.6557 19.0078 14.6557C18.4599 14.6557 18.0161 12.5071 18.0161 9.85714C18.0161 7.20713 18.4601 5.05859 19.0078 5.05859C19.5555 5.05859 19.9998 7.20694 19.9998 9.85714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 9.85646C17.4688 12.8142 16.2061 15.2129 14.6485 15.2129C13.0908 15.2129 11.8281 12.8142 11.8281 9.85646C11.8281 6.8987 13.0906 4.5 14.6483 4.5C16.2059 4.5 17.4686 6.89793 17.4686 9.85646",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 9.85772C11.2812 13 8.75578 15.5473 5.6407 15.5473C2.52561 15.5473 0 12.9994 0 9.85772C0 6.71603 2.52542 4.16797 5.6407 4.16797C8.75598 4.16797 11.2812 6.71546 11.2812 9.85772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleIcon);
export default __webpack_public_path__ + "static/media/bubble_icon.a95f95f46c92ae7b25fa9e72f718fd27.svg";
export { ForwardRef as ReactComponent };